import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.license-management', {
        url: '/licenseManagement',
        component: 'licenseManagement',
        redirectTo: 'company.license-management.current-plan',
        resolve: {
            licenseDetails,
            licenseTiers
        },
    });
}

/** @ngInject */
function licenseDetails(LicenseManagementService, $stateParams) {
    return LicenseManagementService.getLicenseDetails($stateParams.companyId);
}

/** @ngInject */
function licenseTiers(LicenseManagementService, $stateParams) {
    return LicenseManagementService.getLicenseTiers($stateParams.companyId);
}



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/license-management.state.js